import React from "react";
import Typography from "@mui/material/Typography";
import { TypeAnimation } from "react-type-animation";
import AboutMeAnimationFile from "../Components/aboutMeAnimation";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grow from "@mui/material/Grow";
import Slide from "@mui/material/Slide";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/system";
import { motion } from "framer-motion";

const skills = [
  "Python",
  "SQL",
  "Machine Learning",
  "Time Series Forecasting",
  "FastAPI",
  "Power BI",
  "ReactJS",
  "TypeScript",
  "Node.js",
];

const AboutMe = () => {
  return (
    <div>
      <Box sx={{ padding: "20px" }}>
        <Box
          sx={{
            backgroundColor: "#151619",
            paddingBottom: "40px",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              justifyContent: "space-evenly",
              alignItems: "center",
              gap: "40px",
              padding: "20px 40px",
            }}
          >
            <Box sx={{ flex: 1, maxWidth: 480 }}>
              <motion.div
                initial={{ opacity: 0, x: -40 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
              >
                <Typography
                  variant="h4"
                  sx={{ color: "white", fontWeight: 700, mb: 1 }}
                >
                  Hi, I am Pranav Kalra!
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#53b374", fontWeight: 600, mb: 2 }}
                >
                  Analytics & Machine Learning | McGill MMA | Full-Stack
                  Developer
                </Typography>
                <Card
                  sx={{
                    backgroundColor: "#09315d",
                    borderRadius: "16px",
                    mb: 3,
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="body1"
                      sx={{ color: "#d0e8ff", lineHeight: 1.8 }}
                    >
                      Analytical and data-driven professional with a background
                      in Electrical Engineering and a recent graduate of the
                      Master of Management in Analytics (MMA) at McGill
                      University (Sept 2026). Proven experience designing
                      end-to-end predictive modeling pipelines, engineering
                      robust SQL/Python data workflows, and performing rigorous
                      data validation on financial banking systems. Highly adept
                      at translating complex statistical analyses into
                      evidence-based business strategies that mitigate risk and
                      optimize operational performance.
                    </Typography>
                  </CardContent>
                </Card>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {skills.map((skill) => (
                    <Chip
                      key={skill}
                      label={skill}
                      sx={{
                        backgroundColor: "#1e3a5f",
                        color: "#7ec8e3",
                        fontWeight: 600,
                        "&:hover": {
                          backgroundColor: "#53b374",
                          color: "#000",
                        },
                        transition: "all 0.2s",
                      }}
                    />
                  ))}
                </Box>
              </motion.div>
            </Box>

            <Box sx={{ flex: "0 0 auto" }}>
              <Grow in={true}>
                <Card
                  sx={{ backgroundColor: "transparent", boxShadow: "none" }}
                >
                  <AboutMeAnimationFile />
                </Card>
              </Grow>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default AboutMe;
